import script from "./addClass.vue?vue&type=script&setup=true&lang=js"
export * from "./addClass.vue?vue&type=script&setup=true&lang=js"

import "./addClass.vue?vue&type=style&index=0&id=23ad8e5d&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23ad8e5d"]])

export default __exports__